// extracted by mini-css-extract-plugin
export default {"sendToMessenger":"_2-iGPYkowu4DShChgqfsN4","refreshStatus":"SLsysWB6_bZ84aF6KG-yq"};